import React from 'react';
import { Reveal } from './Reveal';
import { FlapText } from './FlapText';
import { GridRails } from './GridRails';
import { useNow } from '../hooks/useNow';
import { zonedParts } from '../utils/timeZones';
import { worldClocks } from '../data/worldClocks';

/** Office clocks: a compact band of three split-flap times, inside the page rails. */
export function WorldClocksSection() {
  const now = useNow();
  const seconds = String(now.getSeconds()).padStart(2, '0');
  return <section id="offices" aria-label="Office local times" className="relative border-y border-mist-line bg-white" data-id="element-440" data-mp="2iszf4oowydm7">
      <GridRails data-id="element-441" data-mp="2wkntkymmxe6c" />
      <Reveal data-id="element-442" data-mp="2wj2yn7wert7y">
        <ul className="relative z-10 mx-auto grid max-w-[1720px] grid-cols-1 gap-2.5 px-9 py-5 sm:grid-cols-3 sm:gap-6 sm:py-7 md:px-24 md:py-8 lg:px-32" data-id="element-443" data-mp="2wjmhcqtvuln1">
          {worldClocks.map(c => {
          const t = zonedParts(now, c.timeZone);
          const time = `${t.hours}:${t.minutes}:${seconds}`;
          return <li key={c.code} className="flex items-center justify-between gap-4 sm:justify-center" data-id="element-444" data-mp="31he8vjqm85qp">
                <span className="font-accent text-[11px] uppercase tracking-[0.08em] text-ink/45" data-id="element-445" data-mp="1zb3pkesyezoh">{c.code}</span>
                <span className="inline-flex items-center gap-[3px] sm:gap-[5px]" role="text" aria-label={`${c.city} ${time}`} data-id="element-446" data-mp="23cynrafl8wy1">
                  <FlapText text={t.hours} tone="light" label="" data-id="element-447" data-mp="28cuqz7ggokcj" />
                  <span aria-hidden="true" className="font-accent text-[11px] text-ink/30 sm:text-[14px]" data-id="element-448" data-mp="2db4npmhu3t09">:</span>
                  <FlapText text={t.minutes} tone="light" label="" data-id="element-449" data-mp="2i9g1u9f5wpoa" />
                  <span aria-hidden="true" className="font-accent text-[11px] text-ink/30 sm:text-[14px]" data-id="element-450" data-mp="2i7mu0qstbzep">:</span>
                  <FlapText text={seconds} tone="light" label="" data-id="element-451" data-mp="2r21ed7s7a04o" />
                </span>
              </li>;
        })}
        </ul>
      </Reveal>
    </section>;
}